import Model from 'flarum/common/Model';
export default class PollGroup extends Model {
  name() {
    return Model.attribute('name').call(this);
  }
  createdAt() {
    return Model.attribute('createdAt', Model.transformDate).call(this);
  }
  polls() {
    return Model.hasMany('polls').call(this) || null;
  }
  canEdit() {
    return Model.attribute('canEdit').call(this);
  }
  canDelete() {
    return Model.attribute('canDelete').call(this);
  }
}
flarum.reg.add('fof-polls', 'forum/models/PollGroup', PollGroup);